interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
}

/**
 * StepIndicator displays "Step X of Y" for onboarding flow.
 *
 * Design specs (steps.md):
 * - Font: DM Sans Bold, 18px base (scales to 20px at md, 22px at lg)
 * - Color: #007CAD (Dark Blue)
 * - Letter spacing: -0.72px
 * - Alignment: Center
 */
export default function StepIndicator({
  currentStep,
  totalSteps,
  className = '',
}: StepIndicatorProps) {
  return (
    <p
      className={`
        text-[18px] md:text-[20px] lg:text-[22px]
        font-bold
        text-[#007CAD]
        tracking-[-0.72px]
        text-center
        ${className}
      `}
    >
      Step {currentStep} of {totalSteps}
    </p>
  );
}
